// UI state types added by stream F (Section 22 shell, 24.14 store). Kept out of state.ts so the
// shared file only gains field declarations.
import type { HouseholdId, JobId, PersonId } from '../sim/api';

/** Left-panel filter (Section 22: filterable by household or job). */
export type ListFilter =
  | { kind: 'all' }
  | { kind: 'household'; householdId: HouseholdId }
  | { kind: 'job'; jobId: JobId };

export type PeopleSortKey =
  | 'name'
  | 'age'
  | 'sex'
  | 'job'
  | 'strength'
  | 'health'
  | 'happiness'
  | 'trust'
  | 'skill'
  | 'household';

/** 'auto' groups by household above 60 people (Section 3, 22). */
export type PeopleGrouping = 'auto' | 'none' | 'household' | 'job';

export interface PeopleView {
  sortKey: PeopleSortKey;
  sortDir: 'asc' | 'desc';
  groupBy: PeopleGrouping;
  /** Group keys expanded when grouped. */
  expanded: string[];
}

/** Section 22 Jobs: an auto-fill proposal awaiting confirmation (never applied without a press). */
export interface AutoFillProposal {
  turn: number;
  assignments: Record<PersonId, JobId>;
}

export type NoticeCode =
  | 'quota'
  | 'saved'
  | 'save-failed'
  | 'loaded'
  | 'load-failed'
  | 'imported'
  | 'import-failed'
  | 'exported'
  | 'ironman-no-slots'
  | 'storage-unavailable'
  | 'autofill-empty'
  | 'forked';

/** A non-error message for the player, shown in the shell's notice bar. */
export interface Notice {
  code: NoticeCode;
  /** Extra data for the message (a slot name, an error line); never pre-formatted numbers. */
  detail: string | null;
}

/** Section 24.12: the loaded save was played on a different balance or content. */
export interface OlderBalance {
  configDiffers: boolean;
  contentDiffers: boolean;
}

export const initialPeopleView: PeopleView = {
  sortKey: 'name',
  sortDir: 'asc',
  groupBy: 'auto',
  expanded: [],
};
